import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/features/common/service/loader.service';
import { commonService } from 'src/app/services/common.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private loaderService: LoaderService,
        private commonService: commonService
    ) { }

    private totalRequests = 0;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.loadSpinner(true);
        return next.handle(this.addToken(req)).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }

                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    this.totalRequests--;
                    return this.handle403Error(req, next);
                }
                else if (error.status === 423) {
                    sessionStorage.setItem("userIsActive", "false");
                    this.commonService.userIsActive.next(false);
                    return throwError(() => new Error(error?.message));
                }
                else {
                    if(error.error.message)
                    return  throwError(() => new Error(error.error.message|| error.error || error));
                else if(error.error)
                    throw error.error;
                else 
                    throw error.error; 
                }
            }),
            finalize(() => {
                this.totalRequests--;
                if (this.totalRequests === 0) {
                    this.loaderService.loadSpinner(false);
                }
            })
        );
    }

    private handle403Error(req: HttpRequest<any>, next: HttpHandler) {
        return from(this.authService.refreshToken()).pipe(
            switchMap(() => {
                //this.authService.setToken(newToken); // Assuming 13 minute expiry
                return next.handle(this.addToken(req));
            })
        );
    }

    private addToken(req: HttpRequest<any>): HttpRequest<any> {
        const token = this.authService.getToken();
        this.totalRequests++;
        if (token) {
            return req.clone({
                setHeaders: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
        }
        return req;
    }
}
